angular.module('impactx.search').component('ixSupplierItem', {
        bindings: {
            supplier: '<'
        },
        require: {
            listCtrl: '^^ixSupplierList'
        },
        controller: 'SupplierItemCtrl',
        controllerAs: 'itemCtrl',
        templateUrl: 'modules/search/templates/supplier-item.html'
    }
);